<template>
  <div class="m--skin-login" style="height: 100%">
    <header>
      <div class="m-header__top t3-header p-2 text-center">
        <img src="/static/img/makueni-logo.png" class=""/>
        <span class="d-block mt-2"><strong>Makueni County Government</strong></span>
      </div>
    </header>
    <div class="m-grid m-grid--hor m-grid--root m-page">
      <div
        class="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--signin m-login--2 m-login-2--skin-2"
        id="m_login">
        <div class="m-grid__item m-grid__item--fluid m-login__wrapper">
          <div class="m-login__container">
            <div class="m-login__signin ">
              <div class="m-login__head">
                <h3 class="m-login__title">Log In</h3>
              </div>
              <div class="m-login__form m-form" :class="{'has-danger': message}">
                <div class="form-group m-form__group" :class="{'has-danger': errors.has('idNo') }">
                  <input type="text" class="form-control m-input" id="idNo" name="idNo" placeholder="Your ID number"
                         v-model="idNo" v-validate="'required'" data-vv-as="ID number" autocomplete="off">
                  <small v-if="message" v-text="message" class="form-control-feedback"></small>
                  <small v-show="errors.has('idNo')" class="form-control-feedback">{{ errors.first('idNo') }}
                  </small>
                </div>
                <div class="form-group m-form__group" :class="{'has-danger': errors.has('password') }">
                  <input type="password" class="form-control m-input m-login__form-input--last" id="password"
                         name="password" placeholder="Password" v-model="password" v-validate="'required'">
                  <small v-show="errors.has('password')" class="form-control-feedback">
                    {{ errors.first('password') }}
                  </small>
                </div>
                <div class="row m-login__form-sub">
                  <div class="col m--align-right m-login__form-right">
                    <router-link id="m_login_forget_password" to="forgot-password" class="m-link">Forgot password?
                    </router-link>
                  </div>
                </div>
                <div class="m-login__form-action">
                  <button @click="validateCredentials" class="btn btn-custome-login btn-block m-btn- m-btn--custom
                      m-btn--air m-login__btn m-login__btn--custome"
                          :class="{'m-loader m-loader--light m-loader--left': loading }">
                   <i class="fa fa-lock"></i> Log In
                  </button>
                </div>
              </div>
              <div class="m-login__account m--margin-top-20">
                <span class="m-login__account-msg">Don't have an account yet ?</span>&nbsp;&nbsp;
                <router-link to="/sign-up" id="m_login_signup" class="m-link m-link--light m-login__account-link">
                  Register
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "../../api";
  import helper from "../../helpers";
  import Welcome from "../partials/Welcome";

  export default {
    name: "SignIn",
    components: {
      welcome: Welcome
    },
    data() {
      return {
        loading: false,
        message: "",
        idNo: "",
        password: "",
        year: new Date().getFullYear()
      };
    },
    methods: {
      validateCredentials() {
        this.$validator.validateAll().then(valid => {
          if (valid) {
            const data = {
              idNo: this.idNo,
              password: this.password
            };
            const txType = "login";

            this.toggleLoading();
            this.resetMessage();

            api.request(txType, data).then(response => {
              this.toggleLoading();
              let responseData = response.data;

              if (responseData.status === "00") {
                this.$store.commit("SET_USER", responseData.user);
                this.$store.commit("SET_TOKEN", responseData.token);

                if (window.localStorage) {
                  window.localStorage.setItem(
                    "user",
                    JSON.stringify(responseData.user)
                  );
                  window.localStorage.setItem("token", responseData.token);
                }

                this.$router.push("dashboard");
              } else if (responseData.status === "10") {
                this.$store.commit("SET_CONFIRM_TOKEN", responseData.token);
                this.$store.commit("SET_USER", responseData.user);
                helper
                  .infoAlert("You need to confirm your account to log in")
                  .then(() => {
                    this.$router.push("confirm");
                  });
              } else if (responseData.status === "19") {
                this.$store.commit("SET_CHANGE_PASSWORD", true);
                helper
                  .infoAlert(
                    "Please change your password first before log in"
                  )
                  .then(() => {
                    this.$store.commit("SET_ID_NUMBER", data.idNo);
                    this.$store.commit("SET_OLD_PASSWORD", data.password);
                    this.$router.push("change-password");
                  });
              } else {
                this.message = responseData.message;
              }
            })
              .catch(error => {
                this.message = "An error occured. Please try again later";
                console.log(error);
              });
          }
        })
          .catch(() => {
            console.log("Validations failed");
          });
      },
      toggleLoading() {
        this.loading = !this.loading;
      },
      resetMessage() {
        this.message = "";
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/auth/SignIn.vue